// Common button style theme with purple colors
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

// Create a styled button with the purple theme
export const PurpleButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#3a1a5a', // Dark purple to match the login page background
  color: 'white',
  borderRadius: '4px',
  textTransform: 'none', // Prevents all caps
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .2)',
  '&:hover': {
    backgroundColor: '#2a1140', // Darker shade of the same purple on hover
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, .3)',
  },
  transition: 'all 0.2s ease-in-out',
}));

export default PurpleButton;